const enterpriseManagement = {
  path: 'enterpriseManagement/:pages',
  component: resolve => require(['../../../../pages/modules/enterpriseManagement'], resolve)
}

export default enterpriseManagement
